import { render } from "./CardCampaign.vue?vue&type=template&id=e5fd273e"
import script from "./CardCampaign.vue?vue&type=script&lang=js"
export * from "./CardCampaign.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__